import React from 'react';
import { BundleLanding } from '../components/Product/BundleLanding';

const EssentialPage: React.FC = () => (
  <BundleLanding
    bundleId="one-and-done"
    seoTitle="Essential Pack — Hydration & Vitamin Recovery"
    seoDescription="The Essential Pack from RaveRemedy: one tub of premium hydration and vitamin recovery blend. Free shipping Australia-wide."
    canonical="https://raveremedy.com/essential"
    heroTagline="One tub of premium hydration & recovery — free shipping Australia-wide."
  />
);

export default EssentialPage;
